import { Sniff, bindMethod } from './chunk-QF7HVQZZ.js';

// src/wheel.ts
var WheelKeyDispatcher = class {
  constructor() {
    this.subs = [];
    this.len = 0;
    this.busy = false;
    this.ff = Sniff.isFirefox;
    this.delta = 0;
    this.e = void 0;
    this.eT = void 0;
    this.eK = void 0;
    bindMethod(this, [
      "_fn",
      "_run",
      "_wheel",
      "_key"
    ]);
    document.body.addEventListener("wheel", this._fn.bind(this), {
      passive: false
    });
    document.addEventListener("keydown", this._fn.bind(this));
  }
  add(sub) {
    this.subs.push(sub);
    this.len++;
  }
  remove(id) {
    let i = this.len;
    for (; i--; ) {
      const sub = this.subs[i];
      if (sub?.id === id) {
        this.subs.splice(i, 1);
        this.len--;
        return;
      }
    }
  }
  _fn(e) {
    this.e = e;
    this.eT = e.type;
    this.eK = "key" in e ? e.key : void 0;
    if (this.len > 0) {
      if (this.eT === "keydown") {
        const k = this.eK || "";
        const handled = k === "ArrowUp" || k === "ArrowDown" || k === "PageUp" || k === "PageDown" || k === "Home" || k === "End" || k === " ";
        if (handled && !e.metaKey && !e.ctrlKey && e.cancelable)
          e.preventDefault();
      } else if (this.eT === "wheel" && e.cancelable) {
        e.preventDefault();
      }
      if (!this.busy) {
        this.busy = true;
        this._run();
      }
    }
  }
  _run() {
    if (this.eT === "wheel") this._wheel();
    else if (this.eT === "keydown") this._key();
  }
  _wheel() {
    const e = this.e;
    const wheelEvent = e;
    const dy = "wheelDeltaY" in wheelEvent && wheelEvent.wheelDeltaY !== void 0 ? wheelEvent.wheelDeltaY : e.deltaY * -1;
    const scale = this.ff && e.deltaMode === 1 ? 0.833333 : 0.555556;
    this.delta = -dy * scale;
    this._cb("w");
  }
  _key() {
    const k = this.eK || "";
    const base = "Arrow";
    const isUp = k === base + "Up" || k === base + "Left";
    const isDown = k === base + "Down" || k === base + "Right";
    const isSpace = k === " ";
    if (isUp || isDown || isSpace) {
      let delta = 100;
      if (isUp) delta *= -1;
      else if (isSpace) {
        const shiftKey = this.e.shiftKey;
        const sign = shiftKey ? -1 : 1;
        delta = (window.innerHeight - 40) * sign;
      }
      this.delta = delta;
      this._cb("k");
    } else {
      this.busy = false;
    }
  }
  _cb(type) {
    let i = this.len;
    for (; i--; ) {
      const sub = this.subs[i];
      if (!sub) continue;
      if (type === "w" && sub.k) continue;
      sub.cb(this.delta);
    }
    this.busy = false;
  }
};
var WheelKeys = new WheelKeyDispatcher();
var WK_ID = 0;
var WheelKeySubscription = class {
  constructor(config = {}) {
    this.cb = config.cb ?? (() => {
    });
    this.k = !!config.k;
    this.id = WK_ID++;
  }
  on() {
    WheelKeys.add({ id: this.id, cb: this.cb, k: this.k });
  }
  off() {
    WheelKeys.remove(this.id);
  }
};

export { WheelKeySubscription, WheelKeys };
//# sourceMappingURL=chunk-HOEPTDHF.js.map
//# sourceMappingURL=chunk-HOEPTDHF.js.map